import { render } from "./EventsAdmin.vue?vue&type=template&id=49ad023d&scoped=true"
import script from "./EventsAdmin.vue?vue&type=script&lang=js"
export * from "./EventsAdmin.vue?vue&type=script&lang=js"

import "./EventsAdmin.vue?vue&type=style&index=0&id=49ad023d&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\merk\\Documents\\_kwork\\virginia79\\lk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ad023d"]])

export default __exports__